import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    users: [],
    adminData: {},
    betaUsers: [],
    blogs: [],
    tracks: [],
    sessions: [],
    publishings: [],
    bloggers: [],
    activeBloggers: [],
    crew: [],
    activeCrew: [],
    tools: [],
    companies: [],
    activeTools: [],
    connections: [],
    activeConnections: [],
    presentations: [],
    activePresentations: [],
    activeCompanies: [],
    items: [],
    beta: [],
    journey_asset_image: []
  },
  getters: {
    adminData(state) {
      return state.adminData;
    },
    users(state) {
      return state.users;
    },
    betaUsers(state) {
      return state.betaUsers;
    },
    blogs(state) {
      return state.blogs;
    },
    tracks(state) {
      return state.tracks;
    },
    publishings(state) {
      return state.publishings;
    },
    sessions(state) {
      return state.sessions;
    },
    bloggers(state) {
      return state.bloggers;
    },
    companies(state) {
      return state.companies;
    },
    guides(state) {
      return state.crew;
    },
    tools(state) {
      return state.tools;
    },
    presentations(state) {
      return state.presentations;
    },
    connections(state) {
      return state.connections;
    },
    activeBloggers(state) {
      return state.activeBloggers;
    },
    journey_asset_image(state) {
      return state.journey_asset_image;
    }
  },
  actions: {
    sendEmail({ commit, state }, userId) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const emailRef = db.collection("emails");

        const payloadFamilyInvite = {
          from: {
            email: "hi@heartbeatfam.com"
          },
          to: [
            {
              email: "savalas@heartbeatfam.com"
            }
          ],
          personalization: [
            {
              email: "savalas@heartbeatfam.com",
              data: {
                account_name: "Mary Jewell",
                support_email: "hi@heartbeatfam.com",
                recipient_name: "Savalas Colbert",
                invitation_link:
                  "https://heartbeatfam.com/invite/sadfqerdfdfdfdf"
              }
            }
          ],
          template_id: "z3m5jgr8po0ldpyo"
        };

        // Set the "capital" field of the city 'DC'
        return emailRef
          .add(payloadFamilyInvite)
          .then(function() {
            console.log("Email Added!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    getUsers({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let usersRef = db.collection("users");
        let users = [];
        usersRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              users.push(Object.assign({}, doc.data(), { userRef: doc.id }));
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_USERS", users);
        res(users);
      });
    },
    getBetaUsers({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let usersRef = db
          .collection("_beta_users")
          .doc("info")
          .collection("emails");
        let beta_users = [];
        usersRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              beta_users.push(
                Object.assign({}, doc.data(), { userRef: doc.id })
              );
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_BETA_USERS", beta_users);
        res(beta_users);
      });
    },
    updateAdminDashboard({ commit, state }, { uid, type, status }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userRef = db.collection("users").doc(uid);

        return userRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            admin: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: type,
                status: status
              }
            }
          };
          return userRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    /*GUIDES*/
    getGuides({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let crewRef = db.collection("listings/guides/items");
        let crew = [];
        let activeguides = [];
        crewRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              if (doc.data().status && doc.data().status == "active") {
                activeguides.push(
                  Object.assign({}, doc.data(), { id: doc.id })
                );
              }
              crew.push(Object.assign({}, doc.data(), { id: doc.id }));
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_CREW", crew);
        commit("SET_ACTIVE_CREW", activeguides);
        res(crew);
      });
    },
    makeUserGuide({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    updateGuideDashboard({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            guide: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addNewGuide({ commit, state }, { guide, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guidesRef = db.collection("listings/guides/items");
        guide.userId = null;
        guidesRef
          .add({
            _created_at: new Date(),
            _created_by: createdBy,
            status: guide.status,
            title: guide.title,
            profile: {
              bio: guide.bio,
              expertise: guide.expertise,
              profileName: guide.profileName
            },
            user: {
              email: guide.email,
              imgURL: guide.imgURL,
              firstname: guide.fullName.split(" ")[0],
              lastname: guide.fullName
                .split(" ")
                .slice(1)
                .join(" "),
              phoneNumber: guide.phoneNumber,
              userId: null
            }
          })
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log("Error addig guide document: ", error);
          });
      });
    },
    updateGuide({ commit, state }, { guide, updatedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let guidesRef = db.collection("listings/guides/items");
        guidesRef
          .where("user.email", "==", guide.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            if (data.user && !data.user.userId) {
              data.user.firstname = guide.fullName.split(" ")[0];
              data.user.lastname = guide.fullName
                .split(" ")
                .slice(1)
                .join(" ");
              data.user.email = guide.email;
              data.user.imgURL = guide.imgURL;
              data.user.phoneNumber = guide.phoneNumber;
              data.profile.bio = guide.bio;
              data.profile.expertise = guide.expertise;
              data.profile.profileName = guide.profileName;
            } else {
              if (data.profile && data.profile._account) {
                data.profile._account.type = guide.accountType;
                data.profile._account.status = guide.accountStatus;
                data.profile._account._updated_at = new Date();
              } else {
                data.profile = {
                  ...data.profile,
                  _account: {
                    _created_at: new Date(),
                    type: guide.accountType,
                    status: guide.accountStatus
                  }
                };
              }
            }
            data.status = guide.status;
            data.title = guide.title;
            data._updated_by = updatedBy;
            data._updated_at = new Date();
            guidesRef
              .doc(docId)
              .update(data)
              .then(() => {
                if (data.user && data.user.userId) {
                  let guideRef = db.collection("users").doc(data.user.userId);
                  guideRef.get().then(doc => {
                    let userData = doc.data();
                    if (
                      userData._dashboards &&
                      userData._dashboards.guide &&
                      userData._dashboards.guide._account
                    ) {
                      userData._dashboards.guide._account.type =
                        guide.accountType;
                      userData._dashboards.guide._account.status =
                        guide.accountStatus;
                      userData._dashboards.guide._account._updated_at = new Date();
                    }
                    guideRef.update(userData).then(() => {
                      res(true);
                    });
                  });
                } else {
                  res(true);
                }
              })
              .catch(error => {
                rej(error);
                console.log("Error updating guide documents: ", error);
              });
          });
      });
    },
    deleteGuide({ commit, state }, { guide, deletedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let guidesRef = db.collection("listings/guides/items");
        guidesRef
          .where("user.email", "==", guide.user.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            data._deleted_at = new Date();
            data._deleted_by = deletedBy;
            guidesRef
              .doc(docId)
              .update(data)
              .then(() => {
                res(true);
              })
              .catch(error => {
                rej(error);
                console.log("Error addig guide document: ", error);
              });
          });
      });
    },
    /*BLOGS*/
    getBlogs({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogsRef = db.collection("listings/blogs/items");
        let blogs = [];
        blogsRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              blogs.push(Object.assign({}, doc.data()));
            });
          })
          .catch(function(error) {
            console.log("Error getting blog documents: ", error);
          });
        commit("SET_BLOGS", blogs);
        res(blogs);
      });
    },
    updateBlog({ commit, state }, data) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db.collection("listings/blogs/items").doc(data.id);
        listingBlogRef
          .get()
          .then(function(doc) {
            let blog = doc.data();
            if (blog.blog) {
              blog.blog._updated_at = new Date();
              blog.blog.title = data.title;
              blog.blog.mins = data.mins;
              blog.blog.summary = data.summary;
              blog.blog.imgURL = data.imgURL;
              blog.blog.wpId = data.wpId;
            } else {
              blog = {
                ...doc.data(),
                blog: {
                  _created_at: new Date(),
                  title: data.title,
                  mins: data.mins,
                  summary: data.summary,
                  imgURL: data.imgURL,
                  wpId: data.wpId
                }
              };
            }
            blog.blogger = data.blogger;
            blog.slug = data.slug;
            blog._updated_at = new Date();
            return listingBlogRef
              .update(blog)
              .then(function() {
                console.log("Blog Successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating Blog: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    updateBlogStatus({ commit, state }, data) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db.collection("listings/blogs/items").doc(data.id);
        listingBlogRef
          .get()
          .then(function(doc) {
            let blog = doc.data();
            const update = {
              _updated_at: new Date(),
              _updated_by: data.by,
              status: data.status
            };

            if (data.status === "active") {
              update._published_at = new Date();
              update._published_by = data.by;
            }
            return listingBlogRef
              .update({ ...update })
              .then(function() {
                console.log("Blog Successfully updated!");
                const bloggerRef = db.doc(
                  `users/${data.bloggerId}/lists/__blogger_articles`
                );
                return bloggerRef.get().then(doc => {
                  //Update the bloggers blog articles
                  let blog_blogs = { ...doc.data() };
                  //Modify user blog status when data is proper
                  if (blog_blogs.blogs && Array.isArray(blog_blogs.blogs)) {
                    blog_blogs.blogs.forEach(blog => {
                      if (blog.id == data.id) {
                        console.log("match");
                        blog.status = data.status;
                        blog._updated_at = new Date();
                      }
                    });
                  }
                  return bloggerRef
                    .set({
                      ...blog_blogs
                    })
                    .then(function() {
                      console.log("Document successfully updated!");
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating document: ", error);
                      rej(error);
                    });
                });
              })
              .catch(function(error) {
                console.error("Error updating Blog: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    deleteBlog({ commit, state }, { blogId, deletedBy }) {
      return new Promise((res, rej) => {
        let data = null;
        const db = firebase.firestore();
        let blogRef = db.collection("listings/blogs/items").doc(blogId);
        blogRef.get().then(doc => {
          data = doc.data();
          data._deleted_at = new Date();
          data._deleted_by = deletedBy;
          blogRef
            .update(data)
            .then(() => {
              res(true);
            })
            .catch(error => {
              rej(error);
              console.log("Error updating blog document: ", error);
            });
        });
      });
    },
    /*TRACKS*/
    getTracks({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let trackssRef = db.collection("listings/tracks_guide/items");
        let tracks = [];
        trackssRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              tracks.push(Object.assign({}, doc.data()));
            });
          })
          .catch(function(error) {
            console.log("Error getting track documents: ", error);
          });
        commit("SET_TRACKS", tracks);
        res(tracks);
      });
    },
    updateTrack({ commit, state }, data) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db.collection("listings/blogs/items").doc(data.id);
        listingBlogRef
          .get()
          .then(function(doc) {
            let blog = doc.data();
            if (blog.blog) {
              blog.blog._updated_at = new Date();
              blog.blog.title = data.title;
              blog.blog.mins = data.mins;
              blog.blog.summary = data.summary;
              blog.blog.imgURL = data.imgURL;
              blog.blog.wpId = data.wpId;
            } else {
              blog = {
                ...doc.data(),
                blog: {
                  _created_at: new Date(),
                  title: data.title,
                  mins: data.mins,
                  summary: data.summary,
                  imgURL: data.imgURL,
                  wpId: data.wpId
                }
              };
            }
            blog.blogger = data.blogger;
            blog.slug = data.slug;
            blog._updated_at = new Date();
            return listingBlogRef
              .update(blog)
              .then(function() {
                console.log("Blog Successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating Blog: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    updateTrackStatus({ commit, state }, data) {
      return new Promise((res, rej) => {
        let trackType = "guide";

        const db = firebase.firestore();
        let listingTrackRef = db
          .collection(`listings/tracks_${trackType}/items`)
          .doc(data.id);
        listingTrackRef
          .get()
          .then(function(doc) {
            let track = doc.data();
            let slug = "";
            console.log("data", data.status);
            if (data.status == "active") {
              slug = track.doc.title.replace(/\s+/g, "-").toLowerCase();
            }
            return listingTrackRef
              .update({
                _updated_at: new Date(),
                _published_at: new Date(),
                _published_by: data.by,
                status: data.status,
                slug: slug
              })
              .then(function() {
                console.log("Track Status Successfully updated!");
                const ownerRef = db.doc(
                  `users/${data.ownerId}/lists/__${trackType}_tracks`
                );
                return ownerRef.get().then(doc => {
                  let tracks = { ...doc.data() };
                  console.log(data);
                  tracks.tracks.forEach(track => {
                    if (track.id == data.id) {
                      console.log("match");
                      track.status = data.status;
                      track._updated_at = new Date();
                    }
                  });
                  return ownerRef
                    .set({
                      ...tracks
                    })
                    .then(function() {
                      console.log("Document successfully updated!");
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating document: ", error);
                      rej(error);
                    });
                });
              })
              .catch(function(error) {
                console.error("Error updating Track: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    deleteTrack({ commit, state }, { trackId, deletedBy }) {
      return new Promise((res, rej) => {
        let data = null;
        const db = firebase.firestore();
        let blogRef = db.collection("listings/tracks_guide/items").doc(trackId);
        blogRef.get().then(doc => {
          data = doc.data();
          data._deleted_at = new Date();
          data._deleted_by = deletedBy;
          blogRef
            .update(data)
            .then(() => {
              res(true);
            })
            .catch(error => {
              rej(error);
              console.log("Error  deleting track document: ", error);
            });
        });
      });
    },
    /*SESSIONS*/
    getSessions({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let sessionsRef = db.collection("listings/sessions/items");
        let sessions = [];

        sessionsRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              sessions.push(Object.assign({}, doc.data()));
            });
          })
          .catch(function(error) {
            console.log("Error getting sessions documents: ", error);
          });

        commit("SET_SESSIONS", sessions);
        res(sessions);
      });
    },
    updateSessionListing({ commit, state }, { id, ownerId, updates }) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingSessionRef = db
          .collection(`listings/sessions/items`)
          .doc(id);

        listingSessionRef
          .get()
          .then(function(doc) {
            updates._updated_at = new Date();

            return listingSessionRef
              .update({ ...updates })
              .then(function() {
                console.log("Publishing Status Successfully updated!");
                const ownerRef = db.doc(`users/${ownerId}/lists/__sessions`);
                return ownerRef.get().then(doc => {
                  const list_sessions = { ...doc.data() };

                  if (
                    list_sessions.sessions &&
                    Array.isArray(list_sessions.sessions)
                  ) {
                    list_sessions.sessions.forEach(session => {
                      if (session.id == id) {
                        session.status = updates.status_stage;
                        session._updated_at = new Date();
                      }
                    });
                  }
                  return ownerRef
                    .set({
                      ...list_sessions
                    })
                    .then(function() {
                      console.log("Document successfully updated!");
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating document: ", error);
                      rej(error);
                    });
                });
              })
              .catch(function(error) {
                console.error("Error updating Sessions: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    updateSessionStatusOld({ commit, state }, data) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingSessionRef = db
          .collection(`listings/sessions/items`)
          .doc(data.id);

        listingSessionRef
          .get()
          .then(function(doc) {
            const session = doc.data();
            let slug = "";

            const update = {
              _updated_at: new Date(),
              status: data.status
            };

            //Save in doc logic functions
            if (data.status === "republish") {
              const docVersion = {
                _created_at: new Date(),
                name: new Date().valueOf(),
                doc: session.doc
              };

              if (
                session.hasOwnProperty("versions") &&
                Array.isArray(session.versions)
              ) {
                update.versions = session.versions;
                update.versions.push(docVersion);
              } else {
                update.versions = [{ ...docVersion }];
              }
            }

            if (data.status === "publish" || data.status === "republish") {
              //PUBLISH pressed  = on never published
              //TODO: handle slUg registration in V2 -- Do more with the slug
              if (!update.slug)
                update.slug =
                  session &&
                  session.doc_stage &&
                  session.doc_stage.session &&
                  session.doc_stage.session.title
                    ? session.doc_stage.session.title
                        .replace(/\s+/g, "-")
                        .toLowerCase()
                    : null;

              //@todo- needs to check for existing slugg to prevent conflict

              if (!update.slug) throw "invalid session. Contact Admin";
              update.status = "active";
              //Handle Doc Management
              update.doc = session.doc_stage ? session.doc_stage : {}; //error if no stage
              update.doc_stage = null;
            }

            if (data.status === "publish" && !session._published_at) {
              //PUBLISH pressed  = on never published
              update._published_at = new Date();
              update._published_by = data.by;
            }

            return listingSessionRef
              .update({ ...update })
              .then(function() {
                console.log("Publishing Status Successfully updated!");
                const ownerRef = db.doc(
                  `users/${data.ownerId}/lists/__sessions`
                );
                return ownerRef.get().then(doc => {
                  const list_sessions = { ...doc.data() };

                  if (
                    list_sessions.sessions &&
                    Array.isArray(list_sessions.sessions)
                  ) {
                    list_sessions.sessions.forEach(session => {
                      if (session.id == data.id) {
                        console.log("match");
                        session.status = update.status;
                        session._updated_at = new Date();
                      }
                    });
                  }
                  return ownerRef
                    .set({
                      ...list_sessions
                    })
                    .then(function() {
                      console.log("Document successfully updated!");
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating document: ", error);
                      rej(error);
                    });
                });
              })
              .catch(function(error) {
                console.error("Error updating Publishing: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    deleteSession({ commit, state }, { sessionId, deletedBy }) {
      return new Promise((res, rej) => {
        let data = null;
        const db = firebase.firestore();
        let sessionRef = db
          .collection("listings/sessions/items")
          .doc(sessionId);
        sessionRef.get().then(doc => {
          data = doc.data();
          data._deleted_at = new Date();
          data._deleted_by = deletedBy;
          blogRef
            .update(data)
            .then(() => {
              res(true);
            })
            .catch(error => {
              rej(error);
              console.log("Error  deleting publishing document: ", error);
            });
        });
      });
    },
    /*PUBLISHINGS*/
    getPublishings({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let publishingssRef = db.collection("listings/publishings/items");
        let publishings = [];
        publishingssRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              publishings.push(Object.assign({}, doc.data()));
            });
          })
          .catch(function(error) {
            console.log("Error getting publishing documents: ", error);
          });
        commit("SET_PUBLISHINGS", publishings);
        res(publishings);
      });
    },
    updatePublishing({ commit, state }, data) {
      let publishingType = "author";

      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db.collection("listings/blogs/items").doc(data.id);
        listingBlogRef
          .get()
          .then(function(doc) {
            let blog = doc.data();
            if (blog.blog) {
              blog.blog._updated_at = new Date();
              blog.blog.title = data.title;
              blog.blog.mins = data.mins;
              blog.blog.summary = data.summary;
              blog.blog.imgURL = data.imgURL;
              blog.blog.wpId = data.wpId;
            } else {
              blog = {
                ...doc.data(),
                blog: {
                  _created_at: new Date(),
                  title: data.title,
                  mins: data.mins,
                  summary: data.summary,
                  imgURL: data.imgURL,
                  wpId: data.wpId
                }
              };
            }
            blog.blogger = data.blogger;
            blog.slug = data.slug;
            blog._updated_at = new Date();
            return listingBlogRef
              .update(blog)
              .then(function() {
                console.log("Blog Successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating Blog: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    updatePublishingStatus({ commit, state }, data) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingPublishingRef = db
          .collection(`listings/publishings/items`)
          .doc(data.id);
        listingPublishingRef
          .get()
          .then(function(doc) {
            const publishing = doc.data();
            let slug = "";
            console.log("data", data.status);

            const update = {
              _updated_at: new Date(),
              status: data.status
            };

            //Save in doc logic functions
            if (data.status === "republish") {
              const docVersion = {
                _created_at: new Date(),
                name: new Date().valueOf(),
                doc: publishing.doc
              };

              if (
                publishing.hasOwnProperty("versions") &&
                Array.isArray(publishing.versions)
              ) {
                update.versions = publishing.versions;
                update.versions.push(docVersion);
              } else {
                update.versions = [{ ...docVersion }];
              }
            }

            if (data.status === "publish" || data.status === "republish") {
              //PUBLISH pressed  = on never published
              //TODO: handle slUg registration in V2 -- Do more with the slug
              if (!update.slug)
                update.slug = publishing.doc_stage.title
                  .replace(/\s+/g, "-")
                  .toLowerCase();
              update.status = "active";
              //Handle Doc Management
              update.doc = publishing.doc_stage ? publishing.doc_stage : {}; //error if no stage
              update.doc_stage = null;
            }

            if (data.status === "publish" && !publishing._published_at) {
              //PUBLISH pressed  = on never published
              update._published_at = new Date();
              update._published_by = data.by;
            }

            return listingPublishingRef
              .update({ ...update })
              .then(function() {
                console.log("Publishing Status Successfully updated!");
                const ownerRef = db.doc(
                  `users/${data.ownerId}/lists/__publishings`
                );
                return ownerRef.get().then(doc => {
                  const list_publishings = { ...doc.data() };

                  if (
                    list_publishings.publishings &&
                    Array.isArray(list_publishings.publishings)
                  ) {
                    list_publishings.publishings.forEach(publishing => {
                      if (publishing.id == data.id) {
                        console.log("match");
                        publishing.status = update.status;
                        publishing._updated_at = new Date();
                      }
                    });
                  }
                  return ownerRef
                    .set({
                      ...list_publishings
                    })
                    .then(function() {
                      console.log("Document successfully updated!");
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating document: ", error);
                      rej(error);
                    });
                });
              })
              .catch(function(error) {
                console.error("Error updating Publishing: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    deletePublishing({ commit, state }, { publishingId, deletedBy }) {
      return new Promise((res, rej) => {
        let data = null;
        const db = firebase.firestore();
        let blogRef = db
          .collection("listings/publishings/items")
          .doc(publishingId);
        blogRef.get().then(doc => {
          data = doc.data();
          data._deleted_at = new Date();
          data._deleted_by = deletedBy;
          blogRef
            .update(data)
            .then(() => {
              res(true);
            })
            .catch(error => {
              rej(error);
              console.log("Error  deleting publishing document: ", error);
            });
        });
      });
    },
    /*BLOGGERS*/
    getBloggers({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggersRef = db.collection("listings/bloggers/items");
        let bloggers = [];
        let activebloggers = [];
        bloggersRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              if (doc.data().status && doc.data().status == "active") {
                activebloggers.push(
                  Object.assign({}, doc.data(), { bloggerId: doc.id })
                );
              }
              bloggers.push(
                Object.assign({}, doc.data(), { bloggerId: doc.id })
              );
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_BLOGGERS", bloggers);
        commit("SET_ACTIVE_BLOGGERS", activebloggers);
        res(bloggers);
      });
    },
    makeUserBlogger({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/bloggers/items")
          .doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    updateBloggerDashboard({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            blogger: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addNewBlogger({ commit, state }, { blogger, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggersRef = db.collection("listings/bloggers/items");
        blogger.userId = null;
        bloggersRef
          .add({
            _created_at: new Date(),
            _created_by: createdBy,
            status: blogger.status,
            title: blogger.title,
            profile: {
              bio: blogger.bio,
              expertise: blogger.expertise,
              profileName: blogger.profileName
            },
            user: {
              email: blogger.email,
              imgURL: blogger.imgURL,
              firstname: blogger.fullName.split(" ")[0],
              lastname: blogger.fullName
                .split(" ")
                .slice(1)
                .join(" "),
              phoneNumber: blogger.phoneNumber,
              userId: null
            }
          })
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log("Error adding blogger document: ", error);
          });
      });
    },
    updateBlogger({ commit, state }, { blogger, updatedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let bloggersRef = db.collection("listings/bloggers/items");
        bloggersRef
          .where("user.email", "==", blogger.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            if (data.user && !data.user.userId) {
              data.user.firstname = blogger.fullName.split(" ")[0];
              data.user.lastname = blogger.fullName
                .split(" ")
                .slice(1)
                .join(" ");
              data.user.email = blogger.email;
              data.user.imgURL = blogger.imgURL;
              data.user.phoneNumber = blogger.phoneNumber;
              data.profile.bio = blogger.bio;
              data.profile.expertise = blogger.expertise;
              data.profile.profileName = blogger.profileName;
            } else {
              if (data.profile && data.profile._account) {
                data.profile._account.type = blogger.accountType;
                data.profile._account.status = blogger.accountStatus;
                data.profile._account._updated_at = new Date();
              } else {
                data.profile = {
                  ...data.profile,
                  _account: {
                    _created_at: new Date(),
                    type: blogger.accountType,
                    status: blogger.accountStatus
                  }
                };
              }
            }
            data.status = blogger.status;
            data.title = blogger.title;
            data._updated_by = updatedBy;
            data._updated_at = new Date();
            bloggersRef
              .doc(docId)
              .update(data)
              .then(() => {
                if (data.user && data.user.userId) {
                  let bloggerRef = db.collection("users").doc(data.user.userId);
                  bloggerRef.get().then(doc => {
                    let userData = doc.data();
                    if (
                      userData._dashboards &&
                      userData._dashboards.blogger &&
                      userData._dashboards.blogger._account
                    ) {
                      userData._dashboards.blogger._account.type =
                        blogger.accountType;
                      userData._dashboards.blogger._account.status =
                        blogger.accountStatus;
                      userData._dashboards.blogger._account._updated_at = new Date();
                    }
                    bloggerRef.update(userData).then(() => {
                      res(true);
                    });
                  });
                } else {
                  res(true);
                }
              })
              .catch(error => {
                rej(error);
                console.log("Error updating blogger documents: ", error);
              });
          });
      });
    },
    deleteBlogger({ commit, state }, { blogger, deletedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let bloggersRef = db.collection("listings/bloggers/items");
        bloggersRef
          .where("user.email", "==", blogger.user.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            data._deleted_at = new Date();
            data._deleted_by = deletedBy;
            bloggersRef
              .doc(docId)
              .update(data)
              .then(() => {
                res(true);
              })
              .catch(error => {
                rej(error);
                console.log("Error adding blogger document: ", error);
              });
          });
      });
    },
    /*TOOLS --> Resources*/
    getTools({ commit, state }) {
      return new Promise((res, rej) => {
        debugger;

        const db = firebase.firestore();
        let toolsRef = db.collection("listings/tools/items");
        let tools = [];
        let activetools = [];
        toolsRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              if (doc.data().status && doc.data().status == "active") {
                activetools.push(
                  Object.assign({}, doc.data(), { toolId: doc.id })
                );
              }
              tools.push(Object.assign({}, doc.data(), { toolId: doc.id }));
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_TOOLS", tools);
        commit("SET_ACTIVE_TOOLS", activetools);
        res(tools);
      });
    },
    makeUserTool({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingToolRef = db.collection("listings/tools/items").doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingToolRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    updateToolDashboard({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolRef = db.collection("users").doc(uid);

        return toolRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            tool: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return toolRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addNewTool({ commit, state }, { tool, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db.collection("listings/tools/items");
        toolsRef
          .add({
            _created_at: new Date(),
            _created_by: createdBy,
            ...tool
          })
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log("Error adding tool document: ", error);
          });
      });
    },
    updateTool({ commit, state }, { tool, toolId, updatedBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db.collection("listings/tools/items").doc(toolId);
        let data = tool;

        toolsRef.get().then(doc => {
          if (doc.exists) {
            data._updated_by = updatedBy;
            data._updated_at = new Date();

            toolsRef
              .update(data)
              .then(() => {
                res(true);
              })
              .catch(error => {
                rej(error);
                console.log("Error updating tool documents: ", error);
              });
          } else {
            rej("Missing doc");
          }
        });
      });
    },
    deleteTool({ commit, state }, { toolId, deletedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let toolsRef = db.collection("listings/tools/items").doc(toolId);
        toolsRef.get().then(doc => {
          data = doc.data();
          data._deleted_at = new Date();
          data._deleted_by = deletedBy;
          toolsRef
            .update(data)
            .then(() => {
              res(true);
            })
            .catch(error => {
              rej(error);
              console.log("Error deleting tool: ", error);
            });
        });
      });
    },
    /*RESOURCE */
    addAdminData({ commit, state }, { adminDataObject, key, createdBy }) {
      return new Promise((res, rej) => {
        debugger;
        const db = firebase.firestore();
        let adminDataRef = db.doc("admin/data");

        adminDataRef
          .get()
          .then(doc => {
            if (doc.exists) {
              const data = doc.data();

              //Temp
              let existingItemsForKey = data[key];

              adminDataObject._created_by = createdBy;

              if (existingItemsForKey) {
                adminDataRef.update({
                  [key]: [...existingItemsForKey, adminDataObject],
                  _updated_at: new Date()
                });
              } else {
                //First time for this key;
                adminDataRef.set({ [key]: adminDataObject }, { merge: true });
              }
            } else {
              adminDataObject._created_by = createdBy;
              adminDataRef.set({
                _created_at: new Date(),
                [key]: [adminDataObject]
              });
            }
            res(true);
          })
          .catch(err => {
            console.log("error in updating resources :", err);
            rej(err);
          });
      });
    },
    getAdminData({ commit, state }) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let adminDataRef = db.doc("admin/data");

        adminDataRef
          .get()
          .then(doc => {
            if (doc.exists) {
              commit("SET_ADMIN_DATA", doc.data());
            }
            res(true);
          })
          .catch(err => {
            console.log("cold not retrieve admin data :", err);
            rej(err);
          });
      });
    },
    /*CONNECTIONS*/
    getConnections({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let connectionsRef = db.collection("listings/connections/items");
        let connections = [];
        let activeconnections = [];
        connectionsRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              if (doc.data().status && doc.data().status == "active") {
                activeconnections.push(
                  Object.assign({}, doc.data(), { connectionId: doc.id })
                );
              }
              connections.push(
                Object.assign({}, doc.data(), { connectionId: doc.id })
              );
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_CONNECTIONS", connections);
        commit("SET_ACTIVE_CONNECTIONS", activeconnections);
        res(connections);
      });
    },
    makeUserConnection({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingConnectionRef = db
          .collection("listings/connections/items")
          .doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingConnectionRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    updateConnectionDashboard({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let connectionRef = db.collection("users").doc(uid);

        return connectionRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            connection: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return connectionRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addNewConnection({ commit, state }, { connection, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let connectionsRef = db.collection("listings/connections/items");
        connection.userId = null;
        connectionsRef
          .add({
            _created_at: new Date(),
            _created_by: createdBy,
            status: connection.status,
            title: connection.title,
            profile: {
              bio: connection.bio,
              expertise: connection.expertise,
              profileName: connection.profileName
            },
            user: {
              email: connection.email,
              imgURL: connection.imgURL,
              firstname: connection.fullName.split(" ")[0],
              lastname: connection.fullName
                .split(" ")
                .slice(1)
                .join(" "),
              phoneNumber: connection.phoneNumber,
              userId: null
            }
          })
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log("Error addig connection document: ", error);
          });
      });
    },
    updateConnection({ commit, state }, { connection, updatedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let connectionsRef = db.collection("listings/connections/items");
        connectionsRef
          .where("user.email", "==", connection.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            if (data.user && !data.user.userId) {
              data.user.firstname = connection.fullName.split(" ")[0];
              data.user.lastname = connection.fullName
                .split(" ")
                .slice(1)
                .join(" ");
              data.user.email = connection.email;
              data.user.imgURL = connection.imgURL;
              data.user.phoneNumber = connection.phoneNumber;
              data.profile.bio = connection.bio;
              data.profile.expertise = connection.expertise;
              data.profile.profileName = connection.profileName;
            } else {
              if (data.profile && data.profile._account) {
                data.profile._account.type = connection.accountType;
                data.profile._account.status = connection.accountStatus;
                data.profile._account._updated_at = new Date();
              } else {
                data.profile = {
                  ...data.profile,
                  _account: {
                    _created_at: new Date(),
                    type: connection.accountType,
                    status: connection.accountStatus
                  }
                };
              }
            }
            data.status = connection.status;
            data.title = connection.title;
            data._updated_by = updatedBy;
            data._updated_at = new Date();
            connectionsRef
              .doc(docId)
              .update(data)
              .then(() => {
                if (data.user && data.user.userId) {
                  let connectionRef = db
                    .collection("users")
                    .doc(data.user.userId);
                  connectionRef.get().then(doc => {
                    let userData = doc.data();
                    if (
                      userData._dashboards &&
                      userData._dashboards.connection &&
                      userData._dashboards.connection._account
                    ) {
                      userData._dashboards.connection._account.type =
                        connection.accountType;
                      userData._dashboards.connection._account.status =
                        connection.accountStatus;
                      userData._dashboards.connection._account._updated_at = new Date();
                    }
                    connectionRef.update(userData).then(() => {
                      res(true);
                    });
                  });
                } else {
                  res(true);
                }
              })
              .catch(error => {
                rej(error);
                console.log("Error updating connection documents: ", error);
              });
          });
      });
    },
    deleteConnection({ commit, state }, { connection, deletedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let connectionsRef = db.collection("listings/connections/items");
        connectionsRef
          .where("user.email", "==", connection.user.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            data._deleted_at = new Date();
            data._deleted_by = deletedBy;
            connectionsRef
              .doc(docId)
              .update(data)
              .then(() => {
                res(true);
              })
              .catch(error => {
                rej(error);
                console.log("Error addig connection document: ", error);
              });
          });
      });
    },
    /*PRESENTATIONS*/
    getPresentations({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let presentationsRef = db.collection("listings/presentations/items");
        let presentations = [];
        let activepresentations = [];
        presentationsRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              if (doc.data().status && doc.data().status == "active") {
                activepresentations.push(
                  Object.assign({}, doc.data(), { presentId: doc.id })
                );
              }
              presentations.push(
                Object.assign({}, doc.data(), { presentId: doc.id })
              );
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_PRESENTATIONS", presentations);
        commit("SET_ACTIVE_PRESENTATIONS", activepresentations);
        res(presentations);
      });
    },
    makeUserPresent({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingPresentRef = db
          .collection("listings/presentations/items")
          .doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingPresentRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    updatePresentDashboard({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let presentRef = db.collection("users").doc(uid);

        return presentRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            present: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return presentRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addNewPresent({ commit, state }, { present, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let presentationsRef = db.collection("listings/presentations/items");
        present.userId = null;
        presentationsRef
          .add({
            _created_at: new Date(),
            _created_by: createdBy,
            status: present.status,
            title: present.title,
            profile: {
              bio: present.bio,
              expertise: present.expertise,
              profileName: present.profileName
            },
            user: {
              email: present.email,
              imgURL: present.imgURL,
              firstname: present.fullName.split(" ")[0],
              lastname: present.fullName
                .split(" ")
                .slice(1)
                .join(" "),
              phoneNumber: present.phoneNumber,
              userId: null
            }
          })
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log("Error addig present document: ", error);
          });
      });
    },
    updatePresent({ commit, state }, { present, updatedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let presentationsRef = db.collection("listings/presentations/items");
        presentationsRef
          .where("user.email", "==", present.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            if (data.user && !data.user.userId) {
              data.user.firstname = present.fullName.split(" ")[0];
              data.user.lastname = present.fullName
                .split(" ")
                .slice(1)
                .join(" ");
              data.user.email = present.email;
              data.user.imgURL = present.imgURL;
              data.user.phoneNumber = present.phoneNumber;
              data.profile.bio = present.bio;
              data.profile.expertise = present.expertise;
              data.profile.profileName = present.profileName;
            } else {
              if (data.profile && data.profile._account) {
                data.profile._account.type = present.accountType;
                data.profile._account.status = present.accountStatus;
                data.profile._account._updated_at = new Date();
              } else {
                data.profile = {
                  ...data.profile,
                  _account: {
                    _created_at: new Date(),
                    type: present.accountType,
                    status: present.accountStatus
                  }
                };
              }
            }
            data.status = present.status;
            data.title = present.title;
            data._updated_by = updatedBy;
            data._updated_at = new Date();
            presentationsRef
              .doc(docId)
              .update(data)
              .then(() => {
                if (data.user && data.user.userId) {
                  let presentRef = db.collection("users").doc(data.user.userId);
                  presentRef.get().then(doc => {
                    let userData = doc.data();
                    if (
                      userData._dashboards &&
                      userData._dashboards.present &&
                      userData._dashboards.present._account
                    ) {
                      userData._dashboards.present._account.type =
                        present.accountType;
                      userData._dashboards.present._account.status =
                        present.accountStatus;
                      userData._dashboards.present._account._updated_at = new Date();
                    }
                    presentRef.update(userData).then(() => {
                      res(true);
                    });
                  });
                } else {
                  res(true);
                }
              })
              .catch(error => {
                rej(error);
                console.log("Error updating present documents: ", error);
              });
          });
      });
    },
    deletePresent({ commit, state }, { present, deletedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let presentationsRef = db.collection("listings/presentations/items");
        presentationsRef
          .where("user.email", "==", present.user.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            data._deleted_at = new Date();
            data._deleted_by = deletedBy;
            presentationsRef
              .doc(docId)
              .update(data)
              .then(() => {
                res(true);
              })
              .catch(error => {
                rej(error);
                console.log("Error addig tool document: ", error);
              });
          });
      });
    },
    getUserById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingToolRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        listingToolRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
              console.log("Document data:", doc.data());
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    /*COMPANY*/
    getCompanies({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let companiesRef = db.collection("listings/companies/items");
        let companies = [];
        let activecompanies = [];
        companiesRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.data().status && doc.data().status == "active") {
                activecompanies.push(
                  Object.assign({}, doc.data(), { companyId: doc.id })
                );
              }
              companies.push(
                Object.assign({}, doc.data(), { companyId: doc.id })
              );
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_COMPANIES", companies);
        commit("SET_ACTIVE_COMPANIES", activecompanies);
        res(companies);
      });
    },
    makeUserCompany({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/companies/items")
          .doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    addNewCompany({ commit, state }, { company, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let companiesRef = db.collection("listings/companies/items");
        company.companyId = null;
        companiesRef
          .add({
            _created_at: new Date(),
            _created_by: createdBy,
            status: company.status,
            profile: {
              bio: company.bio,
              expertise: company.expertise,
              category: company.category,
              profileName: company.profileName
            },
            company: {
              email: company.email,
              imgURL: company.imgURL,
              name: company.name,
              phoneNumber: company.phoneNumber,
              companyId: null
            }
          })
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log("Error adding company document: ", error);
          });
      });
    },
    updateCompany({ commit, state }, { company, updatedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let companiesRef = db.collection("listings/companies/items");
        companiesRef
          .where("company.email", "==", company.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            if (data.company && !data.company.companyId) {
              data.company.name = company.name;
              data.company.email = company.email;
              data.company.imgURL = company.imgURL;
              data.company.phoneNumber = company.phoneNumber;
              data.profile.bio = company.bio;
              data.profile.expertise = company.expertise;
              data.profile.category = company.category;
              data.profile.profileName = company.profileName;
            } else {
              if (data.profile && data.profile._account) {
                data.profile._account.type = company.accountType;
                data.profile._account.status = company.accountStatus;
                data.profile._account._updated_at = new Date();
              } else {
                data.profile = {
                  ...data.profile,
                  _account: {
                    _created_at: new Date(),
                    type: company.accountType,
                    status: company.accountStatus
                  }
                };
              }
            }
            data.status = company.status;
            data._updated_by = updatedBy;
            data._updated_at = new Date();
            companiesRef
              .doc(docId)
              .update(data)
              .then(() => {
                if (data.user && data.user.userId) {
                  let companyRef = db.collection("users").doc(data.user.userId);
                  companyRef.get().then(doc => {
                    let userData = doc.data();
                    if (
                      userData._dashboards &&
                      userData._dashboards.company &&
                      userData._dashboards.company._account
                    ) {
                      userData._dashboards.company._account.type =
                        company.accountType;
                      userData._dashboards.company._account.status =
                        company.accountStatus;
                      userData._dashboards.company._account._updated_at = new Date();
                    }
                    companyRef.update(userData).then(() => {
                      res(true);
                    });
                  });
                } else {
                  res(true);
                }
              })
              .catch(error => {
                rej(error);
                console.log("Error updating company documents: ", error);
              });
          });
      });
    },
    deleteCompany({ commit, state }, { company, deletedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let companiesRef = db.collection("listings/companies/items");
        companiesRef
          .where("user.email", "==", company.user.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            data._deleted_at = new Date();
            data._deleted_by = deletedBy;
            companiesRef
              .doc(docId)
              .update(data)
              .then(() => {
                res(true);
              })
              .catch(error => {
                rej(error);
                console.log("Error updating company document: ", error);
              });
          });
      });
    },
    updateCompanyAdminDashboard({ commit, state }, { uid, type, status }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userRef = db.collection("users").doc(uid);

        return userRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            company: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: type,
                status: status
              }
            }
          };
          return userRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    /*GENERAL-ADMIN*/
    getItems({ commit, state }, { classType, onlyActive }) {
      //Notes, Events, Companies, Etc
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let itemsRef = db.collection(`listings/${classType}/items`);
        let items = [];
        itemsRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.data().status && doc.data().status == "active") {
                items.push(Object.assign({}, doc.data(), { itemId: doc.id }));
              }
            });
          })
          .catch(function(error) {
            console.log("Error getting user documents: ", error);
          });
        commit("SET_ITEMS", items);
        res(items);
      });
    },
    addItem({ commit, state }, { item, classType, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let itemsRef = db.collection(`listings/${classType}/items`);
        itemsRef
          .add({
            _created_at: new Date(),
            _created_by: createdBy,
            status: "active",
            data: item
          })
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log(`Error adding ${classType} document `, error);
          });
      });
    },
    updateItem({ commit, state }, { company, updatedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let companiesRef = db.collection("listings/companies/items");
        companiesRef
          .where("company.email", "==", company.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            if (data.company && !data.company.companyId) {
              data.company.name = company.name;
              data.company.email = company.email;
              data.company.imgURL = company.imgURL;
              data.company.phoneNumber = company.phoneNumber;
              data.profile.bio = company.bio;
              data.profile.expertise = company.expertise;
              data.profile.category = company.category;
              data.profile.profileName = company.profileName;
            } else {
              if (data.profile && data.profile._account) {
                data.profile._account.type = company.accountType;
                data.profile._account.status = company.accountStatus;
                data.profile._account._updated_at = new Date();
              } else {
                data.profile = {
                  ...data.profile,
                  _account: {
                    _created_at: new Date(),
                    type: company.accountType,
                    status: company.accountStatus
                  }
                };
              }
            }
            data.status = company.status;
            data._updated_by = updatedBy;
            data._updated_at = new Date();
            companiesRef
              .doc(docId)
              .update(data)
              .then(() => {
                if (data.user && data.user.userId) {
                  let companyRef = db.collection("users").doc(data.user.userId);
                  companyRef.get().then(doc => {
                    let userData = doc.data();
                    if (
                      userData._dashboards &&
                      userData._dashboards.company &&
                      userData._dashboards.company._account
                    ) {
                      userData._dashboards.company._account.type =
                        company.accountType;
                      userData._dashboards.company._account.status =
                        company.accountStatus;
                      userData._dashboards.company._account._updated_at = new Date();
                    }
                    companyRef.update(userData).then(() => {
                      res(true);
                    });
                  });
                } else {
                  res(true);
                }
              })
              .catch(error => {
                rej(error);
                console.log("Error updating company documents: ", error);
              });
          });
      });
    },
    deleteItem({ commit, state }, { company, deletedBy }) {
      return new Promise((res, rej) => {
        let docId = null;
        let data = null;
        const db = firebase.firestore();
        let companiesRef = db.collection("listings/companies/items");
        companiesRef
          .where("user.email", "==", company.user.email)
          .get()
          .then(querySnapshot => {
            docId = querySnapshot.docs[0].id;
            data = querySnapshot.docs[0].data();
            data._deleted_at = new Date();
            data._deleted_by = deletedBy;
            companiesRef
              .doc(docId)
              .update(data)
              .then(() => {
                res(true);
              })
              .catch(error => {
                rej(error);
                console.log("Error updating company document: ", error);
              });
          });
      });
    },
    approveUser({ commit, state }, userId) {
      console.log("in store");
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userToApprove = db.collection("users").doc(userId);

        // Set the user approved
        return userToApprove
          .update({
            _beta: new Date()
          })
          .then(function() {
            console.log("User Successfully Approved!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    hideImage({ commit, state }, data) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userToApprove = db
          .collection(`listings/journey_assets/items/images/items/`)
          .doc(data.assetId);

        // Set the user approved
        return userToApprove
          .update({
            _hidden_at: new Date()
          })
          .then(function() {
            console.log("Image hidden!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    restImage({ commit, state }, data) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userToApprove = db
          .collection(`listings/journey_assets/items/images/items/`)
          .doc(data.assetId);

        // Set the user approved
        return userToApprove
          .update({
            _restirceted_at: new Date()
          })
          .then(function() {
            console.log("Image hidden!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    checkBeta({ commit, state }, userId) {
      console.log("in this store this", userId);
      return new Promise((res, rej) => {
        let userData = null;
        const db = firebase.firestore();
        let user = db.collection("users").doc(userId);
        user
          .get()
          .then(doc => {
            userData = doc.data();

            commit("SET_BETA", userData._beta);
            localStorage.setItem("_beta", state.beta);
            console.log("value of beta", state.beta);
            res(userData);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error while setting beta in document: ", error);
            rej(error);
          });
      });
    },
    saveJourneyAsset({ commit, state }, { payload, asset_type }) {
      console.log("payload", payload);
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let assetRef = db.collection(
          `listings/journey_assets/items/${asset_type}/items`
        );
        assetRef
          .add(payload)
          .then(doc => {
            res(true);
          })
          .catch(error => {
            rej(error);
            console.log(`Error adding journey_asset document `, error);
          });
      });
    }
    // updateImageAndTags({commit, state}, {payload, asset_type}) {

    // }
  },
  //synchronous
  mutations: {
    SET_USERS(state, users) {
      if (users) {
        state.users = users;
      } else {
        state.users = [];
      }
    },
    SET_BETA_USERS(state, betaUsers) {
      if (betaUsers) {
        state.betaUsers = betaUsers;
      } else {
        state.betaUsers = [];
      }
    },
    SET_BLOGS(state, blogs) {
      if (blogs) {
        state.blogs = blogs;
      } else {
        state.blogs = [];
      }
    },
    SET_BLOGGERS(state, bloggers) {
      if (bloggers) {
        state.bloggers = bloggers;
      } else {
        state.bloggers = [];
      }
    },
    SET_ACTIVE_BLOGGERS(state, bloggers) {
      if (bloggers) {
        state.activeBloggers = bloggers;
      } else {
        state.activeBloggers = [];
      }
    },
    SET_TRACKS(state, tracks) {
      if (tracks) {
        state.tracks = tracks;
      } else {
        state.tracks = [];
      }
    },
    SET_SESSIONS(state, sessions) {
      if (sessions) {
        state.sessions = sessions;
      } else {
        state.sessions = [];
      }
    },
    SET_PUBLISHINGS(state, publishings) {
      if (publishings) {
        state.publishings = publishings;
      } else {
        state.publishings = [];
      }
    },
    SET_COMPANIES(state, companies) {
      if (companies) {
        state.companies = companies;
      } else {
        state.companies = [];
      }
    },
    SET_ACTIVE_COMPANIES(state, companies) {
      if (companies) {
        state.activeCompanies = companies;
      } else {
        state.activeCompanies = [];
      }
    },
    SET_ADMIN_DATA(state, adminData) {
      if (adminData) {
        state.adminData = adminData;
      } else {
        state.adminData = {};
      }
    },
    SET_CREW(state, crew) {
      if (crew) {
        state.crew = crew;
      } else {
        state.crew = [];
      }
    },
    SET_ACTIVE_CREW(state, crew) {
      if (crew) {
        state.activeCrew = crew;
      } else {
        state.activeCrew = [];
      }
    },
    SET_TOOLS(state, tools) {
      if (tools) {
        state.tools = tools;
      } else {
        state.tools = [];
      }
    },
    SET_ACTIVE_TOOLS(state, tools) {
      if (tools) {
        state.activeTools = tools;
      } else {
        state.activeToools = [];
      }
    },
    SET_CONNECTIONS(state, connections) {
      if (connections) {
        state.connections = connections;
      } else {
        state.connections = [];
      }
    },
    SET_ACTIVE_CONNECTIONS(state, connections) {
      if (connections) {
        state.activeConnections = connections;
      } else {
        state.activeConnections = [];
      }
    },
    SET_PRESENTATIONS(state, presentations) {
      if (presentations) {
        state.presentations = presentations;
      } else {
        state.presentations = [];
      }
    },
    SET_ACTIVE_PRESENTATIONS(state, presentations) {
      if (presentations) {
        state.activePresentations = presentations;
      } else {
        state.activePresentations = [];
      }
    },
    SET_ITEMS(state, type, items) {
      if (items) {
        state.items[type] = items;
      } else {
        state.items[type] = [];
      }
    },
    SET_BETA(state, beta) {
      if (beta !== undefined) {
        state.beta = beta.seconds;
      } else {
        state.beta = "";
      }
    },
    SET_JOURNEY_ASSET_IMAGE(state, journey_asset_image) {
      if (journey_asset_image) {
        state.journey_asset_image = journey_asset_image;
      } else {
        state.journey_asset_image = [];
      }
    }
  }
};
